export default "__VITE_ASSET__ClCl91jd__"